<!-- app-layout.component.html -->
<p-toast [life]="5000" />

<!-- Mobile Sidebar Overlay -->
<div
    *ngIf="isMobile && sidebarVisible"
    class="sidebar-overlay"
    (click)="closeSidebar()"
    (touchend)="onSidebarOverlayTouch($event)">
</div>

<div class="app-container">
    <!-- Sidebar -->
    <div class="sidebar"
         [class.mobile-open]="sidebarVisible"
         [attr.aria-hidden]="isMobile && !sidebarVisible"
         role="navigation">
        <div class="logo-container">
            <h1 class="logo">Anchored Growth</h1>
            <div class="logo-subtitle">Intelligence Command Center</div>
        </div>

        <ul class="nav-menu">
            <li class="nav-item">
                <a routerLink="/dashboard" routerLinkActive="active" class="nav-link" [preserveState]="true" (click)="onSidebarLinkClick()">
                    <i class="pi pi-chart-bar"></i>
                    <span>Dashboard</span>
                </a>
            </li>
            <li class="nav-item">
                <a routerLink="/email-outreach" routerLinkActive="active" class="nav-link" [preserveState]="true" (click)="onSidebarLinkClick()">
                    <i class="pi pi-envelope"></i>
                    <span>Email Outreach</span>
                </a>
            </li>
            <li class="nav-item">
                <a routerLink="/linkedin" routerLinkActive="active" class="nav-link" [preserveState]="true" (click)="onSidebarLinkClick()">
                    <i class="pi pi-linkedin"></i>
                    <span>LinkedIn</span>
                </a>
            </li>
            <li class="nav-item">
                <a routerLink="/inbox" routerLinkActive="active" class="nav-link" [preserveState]="true" (click)="onSidebarLinkClick()">
                    <i class="pi pi-inbox"></i>
                    <span>Unified Inbox</span>
                </a>
            </li>
            <li class="nav-item">
                <a routerLink="/analytics" routerLinkActive="active" class="nav-link" [preserveState]="true" (click)="onSidebarLinkClick()">
                    <i class="pi pi-chart-line"></i>
                    <span>Analytics</span>
                </a>
            </li>
            <li class="nav-item">
                <a routerLink="/patterns" routerLinkActive="active" class="nav-link" [preserveState]="true" (click)="onSidebarLinkClick()">
                    <i class="pi pi-lightbulb"></i>
                    <span>Pattern Insights</span>
                </a>
            </li>
            <li class="nav-item" *ngIf="showMessagingMap">
                <a routerLink="/strategy" routerLinkActive="active" class="nav-link" [preserveState]="true" (click)="onSidebarLinkClick()">
                    <i class="pi pi-sitemap"></i>
                    <span>Messaging Map</span>
                </a>
            </li>
            <!-- <li class="nav-item">
                <a routerLink="/ab-testing" class="nav-link">
                    <i class="pi pi-sliders-h"></i>
                    <span>A/B Testing</span>
                </a>
            </li>
            <li class="nav-item">
                <a routerLink="/calls" class="nav-link">
                    <i class="pi pi-phone"></i>
                    <span>Calls</span>
                </a>
            </li>
            <li class="nav-item">
                <a routerLink="/messaging" class="nav-link">
                    <i class="pi pi-comments"></i>
                    <span>Messaging</span>
                </a>
            </li> -->
            <li class="nav-item">
                <a routerLink="/integrations" routerLinkActive="active" class="nav-link" [preserveState]="true" (click)="onSidebarLinkClick()">
                    <i class="pi pi-link"></i>
                    <span>Integrations</span>
                </a>
            </li>
            <li class="nav-item">
                <a routerLink="/mcp-access" routerLinkActive="active" class="nav-link" [preserveState]="true" (click)="onSidebarLinkClick()">
                    <i class="pi pi-bolt"></i>
                    <span>AI Agent Access</span>
                </a>
            </li>
            <li class="nav-item" *ngIf="canManageUsers">
                <a class="nav-link" routerLink="/users" routerLinkActive="active"
                   [preserveState]="true" (click)="onSidebarLinkClick()">
                    <i class="pi pi-users"></i>
                    <span>User Management</span>
                </a>
            </li>
            <li class="nav-item" *ngIf="canManageCompanies || companies.length === 0">
                <a class="nav-link" routerLink="/company-management" [preserveState]="true" (click)="onSidebarLinkClick()">
                    <i class="pi pi-building mr-2"></i>
                    <span>Company Management</span>
                </a>
            </li>
            <li class="nav-item">
                <a routerLink="/billing" routerLinkActive="active" class="nav-link" [preserveState]="true" (click)="onSidebarLinkClick()">
                    <i class="pi pi-credit-card"></i>
                    <span>Billing</span>
                </a>
            </li>
            <li class="nav-item">
                <a routerLink="/settings" routerLinkActive="active" class="nav-link" [preserveState]="true" (click)="onSidebarLinkClick()">
                    <i class="pi pi-cog"></i>
                    <span>Settings</span>
                </a>
            </li>
        </ul>

        <div class="sidebar-footer">
            <a routerLink="/settings/notifications" routerLinkActive="active" class="nav-link" [preserveState]="true" (click)="onSidebarLinkClick()">
                <i class="pi pi-envelope"></i>
                <span>Email Preferences</span>
            </a>
            <a routerLink="/support" routerLinkActive="active" class="nav-link" [preserveState]="true" (click)="onSidebarLinkClick()">
                <i class="pi pi-question-circle"></i>
                <span>Support</span>
            </a>
        </div>
    </div>

    <!-- Main Content -->
    <div class="main-content">
        <!-- Header -->
        <header class="header">
            <!-- Hamburger Menu for Mobile -->
            <button
                *ngIf="isMobile"
                pButton
                icon="pi pi-bars"
                class="p-button-text hamburger-btn"
                (click)="toggleSidebar()"
                [attr.aria-expanded]="sidebarVisible"
                aria-label="Toggle navigation menu">
            </button>

            <div class="search-container">
                <span class="p-input-icon-left">
                    <p-iconfield>
                        <p-inputicon styleClass="pi pi-search" />
                        <input type="text" pInputText placeholder="Search leads, campaigns..." class="search-input" />
                    </p-iconfield>
                </span>
            </div>

            <div class="header-actions">
                <!-- Company Selector -->
                <div class="company-selector-container" *ngIf="selectedCompany">
                    <label for="company-select" class="company-label">Viewing:</label>
                    <p-select id="company-select" [options]="companies" [(ngModel)]="selectedCompany" optionLabel="companyName"
                        placeholder="Select Company" (onChange)="onCompanyChange($event)" class="company-select"
                        [style]="{'min-width': '200px'}">
                        <ng-template let-company pTemplate="selectedItem">
                            <div class="flex align-items-center gap-2">
                                <i class="pi" [ngClass]="company.companyType === 'parent' ? 'pi-building' : 'pi-briefcase'"
                                    [style.color]="company.companyType === 'parent' ? '#3b82f6' : '#10b981'"></i>
                                <span class="font-medium">{{ company.companyName }}</span>
                            </div>
                        </ng-template>
                        <ng-template let-company pTemplate="item">
                            <div class="flex align-items-center gap-2 p-2">
                                <i class="pi" [ngClass]="company.companyType === 'parent' ? 'pi-building' : 'pi-briefcase'"
                                    [style.color]="company.companyType === 'parent' ? '#3b82f6' : '#10b981'"></i>
                                <div class="flex flex-column">
                                    <span class="font-medium">{{ company.companyName }}</span>
                                    <small class="text-color-secondary">{{ company.userRole }}</small>
                                </div>
                            </div>
                        </ng-template>
                    </p-select>
                </div>
                <!-- <button pButton icon="pi pi-bell" class="p-button-rounded p-button-text"></button> -->
                <button pButton 
                        icon="pi pi-question-circle" 
                        class="p-button-rounded p-button-text"
                        pTooltip="Show Getting Started Tour"
                        tooltipPosition="bottom"
                        (click)="startOnboardingTour()">
                </button>
                <!-- <button pButton icon="pi pi-envelope" class="p-button-rounded p-button-text"></button> -->
                <a href="#" class="logout-link" (click)="logout($event)">Logout</a>
                
            </div>
        </header>

        <!-- Page Content -->
        <div class="page-content">
            <!-- Error Message Display -->
            <div class="error-container p-4 mb-4" *ngIf="error">
                <div class="error-card p-3 border-round surface-card shadow-2">
                    <div class="text-center">
                        <i class="pi pi-exclamation-triangle text-yellow-500 text-4xl mb-3"></i>
                        <h3 class="text-900 font-semibold mb-3">Company Data Not Available</h3>
                        <p class="text-600 mb-4">{{ error }}</p>
                        <button pButton 
                                label="Company Management" 
                                icon="pi pi-building" 
                                class="p-button-primary"
                                routerLink="/company-management"
                                [preserveState]="true"
                                (click)="clearError()">
                        </button>
                    </div>
                </div>
            </div>
            
            <router-outlet *ngIf="!error"></router-outlet>
        </div>
    </div>
</div>

<!-- Global Job Monitor -->
<app-job-monitor></app-job-monitor>